import React from "react";

const TableRowCommonAction = ({ onClick, title, icon }) => {
  return (
    <button type="button" onClick={() => onClick()} className="btn btn-circle">
      <i className={`${icon} text-postive h4`}></i> {title}
    </button>
  );
};

export default TableRowCommonAction;
